export const ctaButtonStyles = {
  whiteSpace: 'nowrap',
};
